import { Caption } from '@liveauctioneers/hammer-ui-core/text';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { TableRow } from './TableRow';

export const AlertTypeRow = () => {
    const formatMessage = useAppFormatMessage();

    return (
        <TableRow
            browser={
                <Caption className="uppercase">
                    {formatMessage(['notificationsPage', 'table', 'header', 'browserAlert'])}
                </Caption>
            }
            email={
                <Caption className="uppercase">
                    {formatMessage(['notificationsPage', 'table', 'header', 'emailAlert'])}
                </Caption>
            }
            sms={
                <Caption className="uppercase">
                    {formatMessage(['notificationsPage', 'table', 'header', 'smsAlert'])}
                </Caption>
            }
            type={
                <Caption className="uppercase">
                    {formatMessage(['notificationsPage', 'table', 'header', 'type'])}
                </Caption>
            }
        />
    );
};
